import { __assign } from 'tslib';
import React, { forwardRef, useRef, useImperativeHandle } from 'react';
import Label from '../Label/Label.js';
import clsx from 'clsx';
import '../../../tailwind.css.js';
import { twMerge } from 'tailwind-merge';
import { clazz, subclazz } from './MenuOption.styles.js';
import useProps from '../../hook/useProps.js';

var MenuOption = forwardRef(function (_props, _ref) {
    var ref = useRef(null);
    var subRef = useRef(null);
    var _a = useProps(_props, ["selected", "disabled", "wrap", "prefix", "suffix", "clazz"]), props = _a.props, rest = _a.rest;
    useImperativeHandle(_ref, function () { return ref.current; });
    var onClick = function (ev) {
        var _a, _b, _c, _d;
        ev.preventDefault();
        ev.stopPropagation();
        if (((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(ev.target)) && !Array.from(((_c = (_b = subRef.current) === null || _b === void 0 ? void 0 : _b.childNodes) === null || _c === void 0 ? void 0 : _c.values()) || []).map(function (action) { return action === ev.target; }).reduce(function (x, y) { return x || y; }, false)) {
            if (!props.disabled) {
                (_d = rest.onClick) === null || _d === void 0 ? void 0 : _d.call(rest, ev);
            }
        }
    };
    return (React.createElement("div", __assign({}, rest, { ref: ref, onClick: onClick, className: twMerge(clsx(clazz(props), rest.className)), style: rest.style }),
        React.createElement("div", { className: twMerge(clsx(subclazz(props), props.clazz)) },
            props.prefix && React.createElement("div", { className: clsx("flex items-center justify-center w-fit h-fit", { "opacity-50": props.disabled }) }, props.prefix),
            React.createElement("div", { className: "flex grow items-center justify-between w-[inherit] h-fit max-h-[inherit]" },
                React.isValidElement(rest.children) ? rest.children : React.createElement(Label, { label: String(rest.children), className: clsx("font-normal w-fit h-fit max-h-[inherit]", { "pl-2": props.prefix, "pr-2": props.suffix, "line-clamp-1": !props.wrap, "leading-1 break-words": props.wrap, "text-disabled-text": props.disabled }) }),
                props.suffix && React.createElement("div", { ref: subRef, className: clsx("flex items-center justify-center w-fit h-fit", { "opacity-50": props.disabled }) }, props.suffix)))));
});

export { MenuOption as default };
